import { Component, type ErrorInfo, type ReactNode } from "react";

export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    // Avoid logging application or credential details in production.
  }

  render() {
    if (this.state.hasError) {
      return <main className="error-state"><h1>Portal temporarily unavailable</h1><p>Please refresh the page to try again.</p></main>;
    }
    return this.props.children;
  }
}
